import { AbilityAction, AbilitySubject } from "@/enums/enums";
import { MerchantPackageRightApplicationModel, RoleApplicationModel } from "@/model/merchant/selectedMerchantModel";

export function DefineAppCenterPermissionAbility(
  roleApplication: RoleApplicationModel,
  merchantPackageRightApplication: MerchantPackageRightApplicationModel,
  can: any
) {
  const { peakAccount, peakAsset, peakBoard, peakPayroll, peakTax, peakEngine } = roleApplication ?? {};
  const { peakLineConnect, peakDocument, peakMobile } = merchantPackageRightApplication ?? {};

  peakAccount && can(AbilityAction.Access, AbilitySubject.PeakAccount);
  peakAsset && can(AbilityAction.Access, AbilitySubject.PeakAsset);
  peakBoard && can(AbilityAction.Access, AbilitySubject.PeakBoard);
  peakPayroll && can(AbilityAction.Access, AbilitySubject.PeakPayroll);
  peakTax && can(AbilityAction.Access, AbilitySubject.PeakTax);
  peakEngine && can(AbilityAction.Access, AbilitySubject.OldPeakAccount);

  peakLineConnect && can(AbilityAction.Access, AbilitySubject.PeakLineConnect);
  peakDocument && can(AbilityAction.Access, AbilitySubject.PeakDocument);
  peakMobile && can(AbilityAction.Access, AbilitySubject.PeakMobile);
}
